import { Link } from "react-router-dom";
import { path } from "@/lib/routes";
import { t } from "@/lib/i18n";

export function Logo({ className = "h-14 w-auto", testId = "header-logo-link" }) {
  return (
    <Link to={path("home")} className="inline-flex shrink-0 rounded-lg" aria-label={t("logoLabel")} data-testid={testId}>
      <img
        src="/images/logo-240.webp"
        srcSet="/images/logo-240.webp 240w, /images/logo-480.webp 480w"
        sizes="120px"
        width="240"
        height="219"
        alt={t("logoAlt")}
        className={className}
      />
    </Link>
  );
}

export function BirdMark({ className = "" }) {
  return (
    <div className={`flex items-center gap-4 ${className}`} aria-hidden="true">
      <span className="h-px w-12 bg-gold/60" />
      <img src="/favicon-48.png" alt="" width="24" height="24" className="h-6 w-6 opacity-90" />
      <span className="h-px w-12 bg-gold/60" />
    </div>
  );
}
